import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import { ROUTES_CONSTANTS } from '@shared/configs';

import { WorkflowStepType, WorkflowStepResultType } from '../../models';

import { DecisionModelService } from '../../services';

import { DECISION_MODEL_STATE_ENUMERATION, redirectDecisionModel } from '../../configs';

@Injectable({ providedIn: 'root' })
export class FinalStep implements WorkflowStepType {
  constructor(private readonly router: Router, private readonly decisionModelService: DecisionModelService) {}

  public execute(injector: Injector): Observable<WorkflowStepResultType> {
    return this.decisionModelService.finalValidations().pipe(
      concatMap((response) => {
        if (response.processState === DECISION_MODEL_STATE_ENUMERATION.APPROVED) {
          this.router.navigate([ROUTES_CONSTANTS.DISPERSION_METHOD]);

          return of({ success: true });
        }
        redirectDecisionModel({ state: response.processState, injector });
        return of({ success: false });
      })
    );
  }
}
